import { render } from "./accommodations.vue?vue&type=template&id=792b72a7&scoped=true"
import script from "./accommodations.vue?vue&type=script&lang=js"
export * from "./accommodations.vue?vue&type=script&lang=js"

import "./accommodations.vue?vue&type=style&index=0&id=792b72a7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792b72a7"]])

export default __exports__